import { render } from "./DetailsClasse.vue?vue&type=template&id=476d8f14"
import script from "./DetailsClasse.vue?vue&type=script&lang=js"
export * from "./DetailsClasse.vue?vue&type=script&lang=js"

import "./DetailsClasse.vue?vue&type=style&index=0&id=476d8f14&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/classe/DetailsClasse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "476d8f14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('476d8f14', __exports__)) {
    console.log('reload')
    api.reload('476d8f14', __exports__)
  }
  
  module.hot.accept("./DetailsClasse.vue?vue&type=template&id=476d8f14", () => {
    console.log('re-render')
    api.rerender('476d8f14', render)
  })

}


export default __exports__